var _Skeleton, _Skeleton2, _Skeleton3;
import { cx } from 'class-variance-authority';
import { Skeleton } from '@crehana/compass.ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SearchInputSkeleton = function SearchInputSkeleton(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: cx(className, 'md:tw-max-w-[50vw] sm:tw-mx-auto', 'tw-rounded-full tw-flex tw-items-center tw-py-0.8 tw-px-1.6',
    // Border
    'tw-border tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-700'),
    children: [_Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-2.4 tw-min-w-2.4 tw-h-2.4 tw-mr-1 tw-rounded-full",
      animated: true
    })), _Skeleton2 || (_Skeleton2 = /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-full tw-h-4 tw-mr-1.6 tw-rounded-full",
      animated: true
    })), _Skeleton3 || (_Skeleton3 = /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-11.2 tw-h-4 tw-rounded-full",
      animated: true
    }))]
  });
};
export default SearchInputSkeleton;